export default {
  icpCloudProviders: [],
  icpCloudSignatureJwt: '',
  icpCloudSignatureInfo: {},
};
